// Composable compartido por los modales de "creación rápida con IA"
// (AiEgressProfileBuilderModal y los builders de dominio que vengan:
// asignatura, evaluaciones, planificación).
//
// Encapsula la conversación con un endpoint builder del backend
// (common/ai_builder.py): POST con streaming SSE, eventos por ítem a medida
// que la IA los completa y un evento "done" final con el resultado validado
// (autoritativo), más el manejo de 403 (ai_component deshabilitado).
import { getCurrentInstance } from "vue";
import restful from "@/utils/restful";

export default function useAiBuilderStream({ url, generate_error_key }) {
  const proxy = getCurrentInstance().proxy;
  const store = proxy.$store;

  function genericError() {
    return proxy.$t(generate_error_key);
  }

  // Refleja en el estado local que el backend deshabilitó el componente de
  // IA del usuario (p. ej. por filtro de contenido).
  function disableAiComponent() {
    const user = store.getters.getUser;
    if (user && user.user_data != null) {
      user.user_data.ai_component = false;
      store.commit("setUser", user);
    }
  }

  async function callBuilder(payload, on_item = null) {
    const response = await restful.PostStream(url, payload, {});
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      if (response.status === 403) disableAiComponent();
      throw new Error(body.error || genericError());
    }
    const content_type =
      (response.headers && response.headers.get("content-type")) || "";
    if (!content_type.includes("text/event-stream")) return response.json();
    // SSE: eventos por ítem a medida que la IA los completa y, al final,
    // un evento "done" con el resultado validado (autoritativo).
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let result = null;
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop();
      for (const line of lines) {
        if (!line.startsWith("data: ")) continue;
        let event = null;
        try {
          event = JSON.parse(line.slice(6));
        } catch (e) {
          continue;
        }
        if (event.type === "error")
          throw new Error(event.error || genericError());
        if (event.type === "done") result = event.result;
        else if (on_item) on_item(event);
      }
    }
    if (result == null) throw new Error(genericError());
    return result;
  }

  return { callBuilder, disableAiComponent };
}
